var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D6D6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1891 16.2248C17.6036 16.6398 17.6036 17.2853 17.1891 17.7003C16.9818 17.9078 16.7284 18 16.452 18C16.1756 18 15.9223 17.9078 15.715 17.7003L11.5 13.4813L7.28503 17.7003C7.07774 17.9078 6.82438 18 6.54798 18C6.27159 18 6.01823 17.9078 5.81094 17.7003C5.39635 17.2853 5.39635 16.6398 5.81094 16.2248L10.0259 12.0058L5.81094 7.78674C5.39635 7.37176 5.39635 6.72622 5.81094 6.31124C6.22553 5.89625 6.87044 5.89625 7.28503 6.31124L11.5 10.5303L15.715 6.31124C16.1296 5.89625 16.7745 5.89625 17.1891 6.31124C17.6036 6.72622 17.6036 7.37176 17.1891 7.78674L12.9741 12.0058L17.1891 16.2248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCta);
export default __webpack_public_path__ + "static/media/close-cta.972055c07007fe6ae97bb8821735b16c.svg";
export { ForwardRef as ReactComponent };